module.exports = __webpack_public_path__ + "img/friends_bg.04c54d41.png";